export const PaypalActionTypes = {

  CALLING_BY_SWITCH_PAYMENT_METHOD_MODAL: 'payment_method_modal_by_subscriptions',
  CALLING_BY_PAYMENT_MODAL: 'payment_modal_by_manager_subscriptions',
  CALLING_BY_MANAGER_INVOICES: 'payment_modal_by_manager_invoices',
  CALLING_BY_LIST_SUBSCRIPTIONS: 'payment_modal_by_list_subscriptions',

};
